$('.hero-slider-wrp').slick({
    centerMode: false,
    centerPadding: '0',
    slidesToShow: 1,
    infinite: true,
    arrows: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 300,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                centerMode: false,
                arrows: false,
                dots: true,
            }
        }
    ]
});

$('.product-slider-box').slick({
    infinite: true,
    arrows: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 1150,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1.2,
                arrows: false,
                infinite: false,
                autoplay: false
            }
        }
    ]
});


$('.review-slider').slick({
    infinite: true,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 1150,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1.2,
            }
        }
    ]
});

$('.preview-bottles').slick({
    infinite: true,
    arrows: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 6,
            }
        },
        {
            breakpoint: 1150,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 4,
            }
        }
    ]
});

$('.rating-slider').slick({
    infinite: true,
    arrows: false,
    dots: true,
    autoplay: true,
});

/* Footer accordain */
$(document).ready(function () {
    $(".footer-info-item h3").click(function () {
        // Check window width
        if ($(window).width() <= 991) {
            // Remove active class from all footer-info-items
            $(".footer-info-item").removeClass("active");

            // Add active class to the parent of the clicked header
            $(this).parent(".footer-info-item").addClass("active");
        }
    });
});


/* Filter Accordian */
$(document).ready(function () {
    $('.accordion-list > li > .answer').hide();

    $('.accordion-list > li').click(function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active").find(".answer").slideUp();
        } else {
            $(".accordion-list > li.active .answer").slideUp();
            $(".accordion-list > li.active").removeClass("active");
            $(this).addClass("active").find(".answer").slideDown();
        }
        return false;
    });

});


/* Filter Sidebar */
$(".filter-btns button").click(function () {
    $("body").addClass("filter-show");
});
$(".overlay-common").click(function () {
    $("body").removeClass("filter-show");
});


/* Content Hide Show */
$(".show-more").click(function () {
    if($(".text").hasClass("show-more-height")) {
      console.log(window.theme.strings.show_less);
      $(this).text(window.theme.strings.show_less);
    } else {
        console.log(window.theme.strings.show_more);
        $(this).text(window.theme.strings.show_more);
    }

    $(".text").toggleClass("show-more-height");
});


$(document).ready(function(){
    $('.swatch-element input[type="radio"]').click(function(){
        var inputValue = $(this).attr("value");
        if(inputValue == 'Kasse'){
          $(".per_bottle").show();
        }else{
          $(".per_bottle").hide();
        }
    });
});

  // window.onscroll = function() {
  //   if(screen.width<760){
  //     if(window.scrollY>1350){
  //       document.querySelector('.MA-sidebar-trigger').classList.add('sticky-atc');
  //     }
  //     else if(window.scrollY<1300){
  //       document.querySelector('.MA-sidebar-trigger').classList.remove('sticky-atc');
  //     } 
  //   }
  // }

  document.addEventListener("DOMContentLoaded", function() {
    function updateCountdown() {
      // First we check if it's the weekend. If so, hide countdown
      var now = new Date();
      var day = now.getDay();

      if (day === 0 || day === 6) {
        document.querySelectorAll("[MA-countdown-time]").forEach(ele => {
          ele.innerHTML = "";
        });
        return;
      }

      var{ timeRemaining, countryTime, cutoffTime } = getTimeRemaining();

      // Handle Finland case - hide countdown completely when time is after 12 PM cutoff
      if (countryTime > cutoffTime) {
        // Hide the countdown completely for Finland when time is after 12 PM cutoff
        document.querySelectorAll("[MA-countdown-time]").forEach(ele => {
          ele.innerHTML = "";
        });
        return;
      }

      document.querySelectorAll("[MA-countdown-time]").forEach(ele => {
        ele.innerHTML = getCountdownHtml(timeRemaining);
      });

      if (timeRemaining < 0) {
        // Countdown is over
        clearInterval(countdownInterval);
        document.querySelectorAll("[MA-countdown-time]").forEach(ele => { 
          ele.innerHTML = "00h 00m 00s" 
        });
      }
    }

    function getTimeRemaining() {    
      // Get the current date and time in the Denmark timezone (CET/CEST)
      var now = new Date();
      var nowUTC = new Date(now.toUTCString().slice(0, -4)); // Convert to UTC and remove timezone info

      var countryOffset = getCountryOffset(nowUTC);
      var countryTime = new Date(nowUTC.getTime() + countryOffset * 60 * 60 * 1000);

      // Set the cutoff time to 12 PM (noon) in the country's local time
      var cutoffTime = new Date(countryTime);
      cutoffTime.setHours(getCutoffHour(), 0, 0, 0); // cutoff time in country's local time

      // Calculate the time remaining
      var timeRemaining = cutoffTime - countryTime;

      return { timeRemaining, countryTime, cutoffTime};
    }

    function getCutoffHour() {
      const countdown = window.themeCountdown || {};
      const host = window.location.hostname;
      const isSweden = Shopify.currency.active === "SEK"
        || host === "dittvin.se"
        || host === "www.dittvin.se";
      const isFinland = Shopify.country === "FI";
      const isNetherlands = Shopify.country === "NL";
      const isGermany = Shopify.country === "DE";

      if (isSweden) return countdown.cutoffHourSE ?? 12;
      if (isFinland) return countdown.cutoffHourFI ?? 14;
      if (isNetherlands) return countdown.cutoffHourNL ?? 14;
      if (isGermany) return countdown.cutoffHourDE ?? 14;
      return countdown.cutoffHourDK ?? 14; // Default: Denmark
    }

    function getCountryOffset(nowUTC) {
      if(Shopify.country == "FI") {

        var finlandOffset = 1; // Default to CET
        if (nowUTC.getMonth() > 2 && nowUTC.getMonth() < 9) {
            finlandOffset = 2; // CEST (Daylight Saving Time)
        }

        return finlandOffset;
      } else {
        // Supports SEK and EUR
        // Calculate Denmark's time offset (CET is UTC+1, CEST is UTC+2)
        var denmarkOffset = 1; // Default to CET
        if (nowUTC.getMonth() > 2 && nowUTC.getMonth() < 9) {
            denmarkOffset = 2; // CEST (Daylight Saving Time)
        }

        return denmarkOffset;
      }
    }

    function getCountdownHtml(timeRemaining) {
      // Time calculations for hours, minutes, and seconds
      var hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      if(Shopify.currency.active == "SEK") {
        return `Beställ inom <strong style="padding-inline:2px;"> ${hours}h, ${minutes}m, ${seconds}s </strong> så skickar vi din beställning idag`;
      } else if(Shopify.country == "FI") {
        return `Tilaa <strong style="padding-inline:2px;"> ${hours}t, ${minutes}m, ${seconds}s </strong> kuluessa ja lähetämme tilauksesi tänään`;
      } else if(Shopify.country == "NL") {
        return `Bestel binnen <strong style="padding-inline:2px;"> ${hours}u, ${minutes}m, ${seconds}s </strong> en wij sturen je bestelling vandaag`;
      } else if(Shopify.country == "DE") {
        return `Bestelle in <strong style="padding-inline:2px;"> ${hours}h, ${minutes}m, ${seconds}s </strong> Versand noch heute!`;
      } else {
        return `Bestil inden for <strong style="padding-inline:2px;"> ${hours}h, ${minutes}m, ${seconds}s </strong> og vi sender din ordre i dag`;  
      }
    }

    // Update the countdown every second
    var countdownInterval = setInterval(updateCountdown, 1000);

    // Initial call to display the countdown immediately
    updateCountdown();
});

document.addEventListener('DOMContentLoaded', function () {
    const stickyForm = document.querySelector('.sticky_form');
    const productQtyBtn = document.querySelector('.MA-product-qty-btn');

    function toggleStickyForm() {
      if (productQtyBtn == null) {
        return;
      }
      
      const rect = productQtyBtn.getBoundingClientRect();
      const isVisible = rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);

      if (isVisible) {
          stickyForm.style.display = 'none'; // Hide the sticky form
      } else {
          stickyForm.style.display = 'block'; // Show the sticky form
      }
    }

    // Run the toggleStickyForm function when the page is loaded and when the user scrolls
    window.addEventListener('scroll', toggleStickyForm);
    window.addEventListener('resize', toggleStickyForm);
    toggleStickyForm(); // Initial check when the page loads
});

document.addEventListener('rebuy:smartcart.ready', (event) => {
  const desktopCartIcon = document.querySelector(".utility-right-bar .cart-icon[data-cart-header-02]");

  if(desktopCartIcon) {
    desktopCartIcon.addEventListener('click', () => {
      Rebuy.SmartCart.show();
    });
  }  

  const fixedCartIcon = document.querySelector('.fixed-right-menu .cart-fixed.cart-icon');

  if(fixedCartIcon) {
    fixedCartIcon.addEventListener('click', () => {
      Rebuy.SmartCart.show();
    });
  }

  const mobileCartIcon = document.querySelector('.header-mb-right .cart-icon');

  if(mobileCartIcon) {
    mobileCartIcon.addEventListener('click', () => {
      Rebuy.SmartCart.show();
    });
  }

  setTimeout(() => {
    if (Shopify.currency.active === 'SEK') {
      const iconsToRemove = [
        ".rebuy-cart__flyout-footer .viabill-icon",
        ".rebuy-cart__flyout-footer .mobilepay-icon",
        ".rebuy-cart__flyout-footer .dankort-icon",
      ]

      iconsToRemove.forEach(icon => {
        const iconToRemove = document.querySelector(icon);

        if (iconToRemove) {
          iconToRemove.remove();
        }
      });
    }
  }, 1000);
});

document.addEventListener('rebuy:cart.change', (event) => {
  const cart = event.detail.cart.cart;

  const headerCartStatuses = document.querySelectorAll('.cart-icon .cartCount');
  if (headerCartStatuses && headerCartStatuses.length > 0) {
    const visibleCount = getVisibleCartCount(cart);
    const countToShow = visibleCount != null ? visibleCount : cart.item_count;
    headerCartStatuses.forEach(__ => __.textContent = countToShow);
  }

});

const moneyFormat = '${{amount}}';

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(number, precision = 2, thousands = '.', decimal = ',') {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ', '');
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', ',');
      break;
    case 'amount_with_period_and_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

jQuery('.slick-track').on('setPosition', function (event, slick) { 
  jQuery(slick.$slides).height('auto').css('height', jQuery(slick.$slideTrack).height() + 'px'); 
});


/* translate rebuy titles from english to danish */

document.addEventListener('DOMContentLoaded', function () {
  function applyTranslations() {
    // Check if translations are available
    if (!window.themeTranslations) return;

    /*
    let rebuySuggestionTitleDesktop = document.querySelector('.rebuy-quick-view__suggestions .rebuy-quick-view__title');
    let rebuySuggestionTitleMobile = document.querySelector('.rebuy-quick-view__suggestions .rebuy-quick-view__search-term-section.rebuy-quick-view-dropdown__search-term-section--mobile .rebuy-quick-view__title.rebuy-quick-view-dropdown__title');
    if(rebuySuggestionTitleDesktop && rebuySuggestionTitleDesktop.textContent !== window.themeTranslations.searchSuggestions) {
      rebuySuggestionTitleDesktop.textContent = window.themeTranslations.searchSuggestions; 
    }
    if(rebuySuggestionTitleMobile && rebuySuggestionTitleMobile.textContent !== window.themeTranslations.searchSuggestions) {
      rebuySuggestionTitleMobile.textContent = window.themeTranslations.searchSuggestions; 
    }

    let rebuySuggestionCollectionTitle = document.querySelector('.rebuy-quick-view__suggestions .rebuy-quick-view__collection-section .rebuy-quick-view__title.rebuy-quick-view-dropdown__title');
    if(rebuySuggestionCollectionTitle && rebuySuggestionCollectionTitle.textContent !== window.themeTranslations.suggestedCollections) {
      rebuySuggestionCollectionTitle.textContent = window.themeTranslations.suggestedCollections; 
    }

    let rebuyRecommendedProductsTitle = document.querySelector('.rebuy-quick-view__suggestions .rebuy-quick-view__product-section .rebuy-quick-view__title.rebuy-quick-view-dropdown__title');
    if(rebuyRecommendedProductsTitle && rebuyRecommendedProductsTitle.textContent !== window.themeTranslations.matchingProducts) {
      rebuyRecommendedProductsTitle.textContent = window.themeTranslations.matchingProducts; 
    }

    let rebuyMatchingCollectionsTitle = document.querySelector('.rebuy-quick-view-dropdown__results .rebuy-quick-view__title');
    if(rebuyMatchingCollectionsTitle && rebuyMatchingCollectionsTitle.textContent !== window.themeTranslations.matchingCollections) {
      rebuyMatchingCollectionsTitle.textContent = window.themeTranslations.matchingCollections; 
    }

    let rebuyMatchingProductsTitle = document.querySelector('.rebuy-quick-view-dropdown__results .rebuy-quick-view__product-section .rebuy-quick-view__title');
    if(rebuyMatchingProductsTitle && rebuyMatchingProductsTitle.textContent !== window.themeTranslations.matchingProducts) {
      rebuyMatchingProductsTitle.textContent = window.themeTranslations.matchingProducts; 
    }
      */

    let rebuySeeMoreBtn = document.querySelector('.rebuy-quick-view__collection-list .see-more');
    if(rebuySeeMoreBtn && rebuySeeMoreBtn.textContent !== window.themeTranslations.seeMore) {
      rebuySeeMoreBtn.textContent = window.themeTranslations.seeMore; 
    }

    /*

    const titleElement = document.querySelector('.rebuy-smart-search-results-page-sidebar-flyout__result-title');
    if (titleElement) {
      const text = titleElement.textContent;
      const beforeQuote = text.split('"')[0]; // Gets text before first quote
      const afterQuote = text.split('"').slice(1).join('"'); // Gets everything after
    
      // Replaces the text before the quote, as it is dynamic content
      titleElement.textContent = text.replace(beforeQuote, window.themeTranslations.showingResultsFor);
    }
      */
  }
  
  applyTranslations();
  setInterval(applyTranslations, 500);
});

// Incorporate badges and information from original Shopify search results into Rebuy Smart Search results

document.addEventListener("rebuy:smartsearch.resultsPage.productsChange", (event) => {

  const products = event.detail.products;
  const searchResults = document.querySelector(".rebuy-smart-search-results-page__container");
  
  setTimeout(() => {
    for (const product of products) {
      const productDiv = searchResults.querySelector(`#rebuy-product-id-${product.id}`);

      // check if product is a subscription (has 'abonnement' tag)
      // let css handle the display
      if (product.tags && (product.tags.includes('Abonnement') || product.tags.includes('abonnement')) && productDiv) {
        productDiv.classList.add('has-abonnement-tag');
      }

      // discount logic
      const discountPercentage = ((product.compareAtPrice - product.price) / product.compareAtPrice) * 100;
  
      if (productDiv && discountPercentage > 0) {
        const discountLabel = document.createElement("div");
        discountLabel.classList.add("product-label", "w3_bg");
 
        // Create <strong class="label sale-label"> element
        const strong = document.createElement("strong");
        strong.classList.add("label", "sale-label");
        strong.textContent = `-${Math.round(discountPercentage)}%`;
 
        // Append <strong> to discountLabel
        discountLabel.appendChild(strong);
 
        productDiv.appendChild(discountLabel);
      }
      
      // check if product has awards
      if (productDiv) {
        const shopifyProduct = findShopifyProductByHandle(product.handle);
        
        if (shopifyProduct && hasAwardBadge(shopifyProduct)) {
          const awardBadge = createAwardBadge(shopifyProduct);
          if (awardBadge) {
            productDiv.appendChild(awardBadge);
          }
        }
      }
    }
  }, 100);
});

// find Shopify product in DOM by handle
function findShopifyProductByHandle(handle) {
  // Look for Shopify products in the original search results
  const shopifyProducts = document.querySelectorAll('[data-json-product]');
  
  for (const shopifyProductElement of shopifyProducts) {
    try {
      const productData = JSON.parse(shopifyProductElement.getAttribute('data-json-product'));
      if (productData.handle === handle) {
        return {
          element: shopifyProductElement,
          data: productData
        };
      }
    } catch (e) {
      console.error('Error parsing product data:', e);
    }
  }
  return null;
}

// check if a Shopify product has award badges
function hasAwardBadge(shopifyProduct) {
  const awardElement = shopifyProduct.element.querySelector('.award-img-one, .award-wrp');
  return awardElement !== null;
}

// create award badge element
function createAwardBadge(shopifyProduct) {
  const awardWrapper = shopifyProduct.element.querySelector('.award-wrp');
  
  if (awardWrapper) {
    // Clone the entire award structure
    const awardBadge = awardWrapper.cloneNode(true);
        
    return awardBadge;
  }
  
  return null;
}

// override the default styles of Recharge subscription widget
// This will inject custom styles into the shadow DOM used by the subscription widget

function injectRechargeStyles(widget, country) {
  if (!widget.shadowRoot) {
    return;
  }

  // Get country-specific styles
  const styles = getCountryStyles(country);
  if (!styles) {
    return;
  }

  // Main widget styles
  const existing = widget.shadowRoot.querySelector("#myCustomStyles");
  if (!existing) {
    const styleEl = document.createElement("style");
    styleEl.id = "myCustomStyles";
    styleEl.textContent = styles.main;
    widget.shadowRoot.appendChild(styleEl);
  }

  // Handle nested Shadow DOM for rc-benefits
  const benefits = widget.shadowRoot.querySelector("rc-benefits");
  if (benefits && benefits.shadowRoot) {
    const benefitsStyleEl = benefits.shadowRoot.querySelector("#benefitsCustomStyles");
    
    if (!benefitsStyleEl && styles.benefits) {
      const styleEl = document.createElement("style");
      styleEl.id = "benefitsCustomStyles";
      styleEl.textContent = styles.benefits;
      benefits.shadowRoot.appendChild(styleEl);
    }
  }

  // Handle nested Shadow DOM for rc-learn-more
  const learnMore = widget.shadowRoot.querySelector("rc-learn-more");
  if (learnMore && learnMore.shadowRoot) {
    const learnMoreStyleEl = learnMore.shadowRoot.querySelector("#learnMoreCustomStyles");
    
    if (!learnMoreStyleEl && styles.learnMore) {
      const styleEl = document.createElement("style");
      styleEl.id = "learnMoreCustomStyles";
      styleEl.textContent = styles.learnMore;
      learnMore.shadowRoot.appendChild(styleEl);
    }
  }

  // Handle nested Shadow DOM for rc-selling-plans
  const sellingPlans = widget.shadowRoot.querySelector("rc-selling-plans");
  if (sellingPlans && sellingPlans.shadowRoot) {
    const sellingPlansStyleEl = sellingPlans.shadowRoot.querySelector("#sellingPlansCustomStyles");
    
    if (!sellingPlansStyleEl && styles.sellingPlans) {
      const styleEl = document.createElement("style");
      styleEl.id = "sellingPlansCustomStyles";
      styleEl.textContent = styles.sellingPlans;
      sellingPlans.shadowRoot.appendChild(styleEl);
    }
  } else if (styles.sellingPlans) {
    // Fallback for delayed loading
    setTimeout(() => {
      const delayedSellingPlans = widget.shadowRoot.querySelector("rc-selling-plans");
      if (delayedSellingPlans && delayedSellingPlans.shadowRoot) {
        const existing = delayedSellingPlans.shadowRoot.querySelector("#sellingPlansCustomStyles");
        if (!existing) {
          const styleEl = document.createElement("style");
          styleEl.id = "sellingPlansCustomStyles";
          styleEl.textContent = styles.sellingPlansDelayed || styles.sellingPlans;
          delayedSellingPlans.shadowRoot.appendChild(styleEl);
        }
      }
    }, 1000);
  }
}

function getCountryStyles(country) {
  const styleConfigs = {
    FI: {
      main: `
        legend.rc-plans__label {
          margin-bottom: 4px !important;
          font-weight: 500 !important;
        }
        
        /* discounted price span */
        span.rc-price[part="rc-purchase-option__discounted-price"] {
          padding-left: 5px !important;
        }
        
        /* Style the selected subscription option */
        .rc-purchase-option[rc-selected] {
          border: 2px solid #7C0000 !important;
          border-radius: 10px !important;
        }
        
        /* Also target regular purchase options */
        .rc-purchase-option {
          border: 2px solid transparent !important;
        }
        
        /* Remove padding bottom from purchase option label */
        .rc-purchase-option__label {
          padding-bottom: 0 !important;
        }
        
        /* Subscribe button font size */
        .rc-purchase-option__selector {
          font-size: 16px !important;
          color: rgb(35, 31, 32) !important;
        }

        .rc-purchase-option__sub-container {
          gap: 4px !important;
        }
      `,
      benefits: `
        /* Benefits list styling */
        p {
          font-size: 14px !important;
          color: rgb(35, 31, 32) !important;
        }
        
        p:first-of-type {
          margin-block-start: 8px !important;
        }
      `,
      learnMore: `
        .rc-learn-more__trigger {
          font-size: 12px !important;
          display: none !important;
        }
      `,
      sellingPlans: `
        legend.rc-plans__label {
          margin-bottom: 4px !important;
          font-weight: 500 !important;
          font-size: 15px !important;
          color: rgb(35, 31, 32) !important;
        }
        
        /* Make interval spans font-weight 500 and smaller font size */
        span.rc-plans-button__interval {
          font-weight: 500 !important;
          font-size: 12px !important;
          text-transform: uppercase !important;
          font-family: "Poppins", sans-serif !important;
          line-height: 26px !important;
        }
        
        /* Change selected button background color */
        .rc-plans-button[data-checked] {
          background: #751e27 !important;
          color: rgb(255, 255, 255) !important;
        }
        
        .rc-plans-button.rc-plans-button__selected {
          background: #751e27 !important;
        }
      `,
      sellingPlansDelayed: `
        legend.rc-plans__label {
          margin-bottom: 4px !important;
          font-weight: 500 !important;
          font-size: 15px !important;
        }
        
        span.rc-plans-button__interval {
          font-weight: 500 !important;
          font-size: 12px !important;
        }
        
        .rc-plans-button[data-checked] {
          background: #751e27 !important;
        }
        
        .rc-plans-button.rc-plans-button__selected {
          background: #751e27 !important;
        }
      `
    },
    SE: {
      main: `
        /* Swedish-specific main styles */
        legend.rc-plans__label {
          margin-bottom: 4px !important;
          font-weight: 500 !important;
        }
        
        /* discounted price span */
        span.rc-price[part="rc-purchase-option__discounted-price"] {
          padding-left: 5px !important;
        }
        
        .rc-purchase-option[rc-selected] {
          border: 2px solid #7C0000 !important;
          border-radius: 10px !important;
        }
        
        .rc-purchase-option {
          border: 2px solid transparent !important;
        }
        
        .rc-purchase-option__label {
          padding-bottom: 0 !important;
        }
        
        .rc-purchase-option__selector {
          font-size: 16px !important;
          color: rgb(35, 31, 32) !important;
        }
      `,
      benefits: `
        /* Swedish benefits styling */
        p {
          font-size: 14px !important;
          color: rgb(35, 31, 32) !important;
        }
        
        p:first-of-type {
          margin-block-start: 8px !important;
        }
        
        /* Target the bullet points */
        li::before {
          background-color: #7C0000 !important;
        }
        
        /* Alternative targeting for bullet styling */
        ul li::before {
          background-color: #7C0000 !important;
        }
      `,
      learnMore: `
        .rc-learn-more__trigger {
          font-size: 12px !important;
          color: #7C0000 !important;
          display: none !important;
        }
      `,
      sellingPlans: `
        legend.rc-plans__label {
          margin-bottom: 4px !important;
          font-weight: 500 !important;
          font-size: 15px !important;
          color: rgb(35, 31, 32) !important;
        }
        
        span.rc-plans-button__interval {
          font-weight: 500 !important;
          font-size: 12px !important;
          text-transform: uppercase !important;
          font-family: "Poppins", sans-serif !important;
          line-height: 26px !important;
        }
        
        .rc-plans-button[data-checked] {
          background: #751e27 !important;
          color: rgb(255, 255, 255) !important;
        }
        
        .rc-plans-button.rc-plans-button__selected {
          background: #751e27 !important;
        }
      `
    },
    DK: {
      main: `
        legend.rc-plans__label {
          margin-bottom: 4px !important;
          font-weight: 500 !important;
        }
        
        /* discounted price span */
        span.rc-price[part="rc-purchase-option__discounted-price"] {
          padding-left: 5px !important;
        }
        
        /* Style the selected subscription option */
        .rc-purchase-option[rc-selected] {
          border: 2px solid #7C0000 !important;
          border-radius: 10px !important;
        }
        
        /* Also target regular purchase options */
        .rc-purchase-option {
          border: 2px solid transparent !important;
        }
        
        /* Remove padding bottom from purchase option label */
        .rc-purchase-option__label {
          padding-bottom: 0 !important;
        }
        
        /* Subscribe button font size */
        .rc-purchase-option__selector {
          font-size: 16px !important;
          color: rgb(35, 31, 32) !important;
        }

        .rc-purchase-option__sub-container {
          gap: 4px !important;
        }
      `,
      benefits: `
        /* Benefits list styling */
        p {
          font-size: 14px !important;
          color: rgb(35, 31, 32) !important;
        }
        
        p:first-of-type {
          margin-block-start: 8px !important;
        }
      `,
      learnMore: `
        .rc-learn-more__trigger {
          font-size: 12px !important;
          display: none !important;
        }
      `,
      sellingPlans: `
        legend.rc-plans__label {
          margin-bottom: 4px !important;
          font-weight: 500 !important;
          font-size: 15px !important;
          color: rgb(35, 31, 32) !important;
        }
        
        /* Make interval spans font-weight 500 and smaller font size */
        span.rc-plans-button__interval {
          font-weight: 500 !important;
          font-size: 12px !important;
          text-transform: uppercase !important;
          font-family: "Poppins", sans-serif !important;
          line-height: 26px !important;
          hyphens: none !important;
          word-break: normal !important;
        }

        @media only screen and (max-width: 749px){
          span.rc-plans-button__interval {
            line-height: 20px !important;
            hyphens: none !important;
            word-break: normal !important;
          }
        }
        
        /* Change selected button background color */
        .rc-plans-button[data-checked] {
          background: #751e27 !important;
          color: rgb(255, 255, 255) !important;
        }
        
        .rc-plans-button.rc-plans-button__selected {
          background: #751e27 !important;
        }
      `,
      sellingPlansDelayed: `
        legend.rc-plans__label {
          margin-bottom: 4px !important;
          font-weight: 500 !important;
          font-size: 15px !important;
        }
        
        span.rc-plans-button__interval {
          font-weight: 500 !important;
          font-size: 12px !important;
        }
        
        .rc-plans-button[data-checked] {
          background: #751e27 !important;
        }
        
        .rc-plans-button.rc-plans-button__selected {
          background: #751e27 !important;
        }
      `
    },
  };

  return styleConfigs[country] || null;
}

function observeRechargeWidget() {
  const observer = new MutationObserver(() => {
    const widget = document.querySelector("recharge-subscription-widget");
    if (!widget) return;

    if (widget.shadowRoot && widget.shadowRoot.querySelector(".rc-purchase-option")) {
      // Get country from Shopify global or default to DK
      const country = (typeof Shopify !== 'undefined' && Shopify.country) ? Shopify.country : "DK";
      injectRechargeStyles(widget, country);
      observer.disconnect();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}



// Initialize on page load
document.addEventListener("DOMContentLoaded", () => {
  const country = (typeof Shopify !== 'undefined' && Shopify.country) ? Shopify.country : "DK";
  
  // Existing logic for FI/SE/DK shadow DOM widgets
  const widget = document.querySelector("recharge-subscription-widget");
  if (widget && widget.shadowRoot) {
    injectRechargeStyles(widget, country);
  } else {
    observeRechargeWidget();
  }
});

// Fallback if DOMContentLoaded already fired
if (document.readyState === 'loading') {
  // DOMContentLoaded listener above will handle this
} else {
  // DOM is already ready
  observeRechargeWidget();
}

// ---------------------------------------------
// When a user has 6 bottles of the same wine in the cart,
// and that wine has a "kasse" variant,
// we replace those 6 bottles with 1 box.
//
// If the product in the cart is already the "kasse" variant,
// the product is added normally
// ---------------------------------------------

// prevents the code from running twice at the same time
let isReplacingSixPacks = false;

// fetch full product data
async function fetchProductByHandle(handle) {
  const res = await fetch(`/products/${handle}.js`);
  if (!res.ok) return null;
  return res.json();
}

// check if the current variant is the first one
function isFirstVariant(product, variantId) {
  const firstVariant = product.variants?.[0];
  if (!firstVariant) return false;
  return String(firstVariant.id) === String(variantId);
}

// get the second variant’s ID (kasse)
function getSecondVariantId(product) {
  const secondVariant = product.variants?.[1];
  if (!secondVariant || !secondVariant.available) return null;
  return secondVariant.id;
}

// find an item in the cart by variant ID
function findCartItemByVariant(cart, variantId) {
  if (!Array.isArray(cart.items)) return null;
  return cart.items.find(
    (item) => String(item.variant_id) === String(variantId)
  );
}

// main function: checks the cart and converts 6 bottles into 1 kasse
async function convertSixSinglesToBox() {
  if (isReplacingSixPacks) return;
  isReplacingSixPacks = true;

  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    if (!Array.isArray(cart.items)) return;

    for (const item of cart.items) {

      if (item.quantity !== 6) continue;

      if (item.product_type === 'Abonnement') continue;

      const handle = item.handle || item.product_handle;
      if (!handle) continue;

      // fetch product data to inspect its variants
      const product = await fetchProductByHandle(handle);
      if (!product || !Array.isArray(product.variants)) continue;

      // only apply logic if this line item is the bottle variant (first variant)
      const isBottle = isFirstVariant(product, item.variant_id);
      if (!isBottle) continue; // means it's already a kasse so skip

      // get the second variant
      const boxVariantId = getSecondVariantId(product);
      if (!boxVariantId) continue; // if there's no box variant skip

      // check if the cart already contains that box
      const existingBoxItem = findCartItemByVariant(cart, boxVariantId);

      if (existingBoxItem) {
        // if there’s already a box in the cart, increase its quantity by 1
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: existingBoxItem.key,
            quantity: existingBoxItem.quantity + 1
          })
        });

      } else {
        // if no box exists yet, add 1 box to the cart
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: boxVariantId,
            quantity: 1
          })
        });
      }

      // remove the initial 6 bottles from the cart
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      });
    }
  } catch (error) {
    console.error('Error while converting 6 bottles to a box:', error);
  } finally {
    // reset flag for future cart updates
    isReplacingSixPacks = false;
  }
}


// debouncing the function 
let sixPackTimer;

function scheduleSixPackCheck() {
  clearTimeout(sixPackTimer);
  sixPackTimer = setTimeout(convertSixSinglesToBox, 120);
}

// ---------------------------------------------------------------------------
// Order handling fee (miljøgebyr) guard.
// Keeps exactly one ORDER_FEE line (quantity 1) in the cart whenever the cart
// contains real products, and removes it when it is the last line left. The
// line is priced at checkout by the order-handling-fee cart transform function
// (total cart kg × per-store rate), so it must already be in the cart when
// checkout starts — that is what makes the fee survive fast buyers and
// express/wallet checkouts.
// Config comes from window.WIOrderFee (snippets/order-fee-guard.liquid, driven
// by the Handling Fee theme settings); without it this is a no-op. The fee
// product carries the rebuy_hidden tag, so the existing hidden-row CSS and
// visible-count logic keep it out of the cart UI.
// ---------------------------------------------------------------------------
let isEnsuringOrderFee = false;
let orderFeeTimer;

function isOrderFeeItem(item) {
  return String(item.sku || '').trim().toUpperCase() === 'ORDER_FEE';
}

async function ensureOrderFee() {
  const config = window.WIOrderFee;
  if (!config || !config.variantId) return;
  if (isEnsuringOrderFee) return;
  isEnsuringOrderFee = true;

  try {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) return;
    const cart = await res.json();
    if (!Array.isArray(cart.items)) return;

    const feeItems = cart.items.filter(isOrderFeeItem);
    const feeUnits = feeItems.reduce((sum, item) => sum + (item.quantity || 0), 0);
    const hasRealProducts = cart.items.length > feeItems.length;

    if (hasRealProducts && feeItems.length === 0) {
      // Fee missing → add it.
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: config.variantId, quantity: 1 }] })
      });
    } else if (!hasRealProducts && feeItems.length > 0) {
      // Fee is the only thing left → remove it.
      const updates = {};
      for (const item of feeItems) updates[item.key] = 0;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
    } else if (feeItems.length > 0 && feeUnits !== 1) {
      // Exactly one fee line at quantity 1.
      const updates = {};
      feeItems.forEach((item, index) => {
        updates[item.key] = index === 0 ? 1 : 0;
      });
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
    } else {
      return; // cart already correct — no refresh needed
    }

    // Re-render the cart UIs with the corrected cart. The resulting
    // rebuy:cart.change re-enters ensureOrderFee once, finds nothing to do,
    // and stops — no loop.
    refreshRebuyCart();
    document.dispatchEvent(new CustomEvent('updateCart'));
  } catch (error) {
    console.error('Error while ensuring the order handling fee line:', error);
  } finally {
    isEnsuringOrderFee = false;
  }
}

function scheduleOrderFeeCheck() {
  clearTimeout(orderFeeTimer);
  orderFeeTimer = setTimeout(ensureOrderFee, 250);
}

// ---------------------------------------------------------------------------
// Header cart widget (sections/header-03.liquid): total, free-shipping message and
// progress bar. Liquid renders it on page load from the cart it was built with and
// stamps that total on .cart-data as data-cart-current. This is the only JS that
// touches the widget afterwards, and it only writes when the cart total differs
// from that stamp, so a page load never re-renders what Liquid already printed.
// halo.js's own free-shipping widget is scoped away from the header for the same
// reason (see FreeShippingMessage there).
// ---------------------------------------------------------------------------
function renderHeaderCart(cart) {
  const wrap = document.querySelector('.cart-wrp .cart-data');
  if (!wrap || !cart) return;

  const total = Math.round(Number(cart.total_price));
  const rendered = Math.round(parseFloat(wrap.dataset.cartCurrent || '0') * 100);
  if (total === rendered) return;
  wrap.dataset.cartCurrent = String(total / 100);

  // Same shop money format as the Liquid `money` filter, formatted by this file's
  // own formatMoney, so the text reads exactly like the first paint. Shopify.formatMoney
  // is not used: it lives in the lazy-loaded jQuery bundle and often does not exist yet.
  const format = window.theme && window.theme.moneyFormat
    ? window.theme.moneyFormat
    : '{{amount}}';

  const totalEl = wrap.querySelector('[data-cart-total]');
  if (totalEl) totalEl.textContent = formatMoney(total, format);

  const threshold = Math.round(parseFloat(wrap.dataset.freeShipping || '0') * 100);
  if (threshold <= 0) return;

  const strings = window.free_shipping_text || {};
  const complete = total >= threshold;

  // Same assembly as the Liquid block: "<msg2> <remaining> <msg3> <b><msg4></b>".
  const messageEl = wrap.querySelector('.free_shipping_massage1');
  if (messageEl) {
    messageEl.innerHTML = complete
      ? (strings.free_shipping_message_1 || '')
      : (strings.free_shipping_message_2 || '') + ' ' + formatMoney(threshold - total, format) + ' ' +
        (strings.free_shipping_message_3 || '') + ' <b>' + (strings.free_shipping_message_4 || '') + '</b>';
  }

  const meter = document.querySelector('.cart-wrp .free_shipping_progress .progress-meter');
  if (meter) {
    meter.style.width = (complete ? 100 : (total / threshold) * 100) + '%';
    meter.classList.toggle('complete', complete);
  }
}

// Update the header cart widget from the cart Rebuy handed us, or from /cart.js
// when the event carried none (page load, the WI drawer's event).
async function updateCartHeaderTotal(cart) {
  try {
    if (!cart) {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      cart = await res.json();
    }
    renderHeaderCart(cart);
  } catch (err) {
    console.error('Failed to update cart total in header', err);
  }
}

// The product tag used to hide line items from the cart. Rebuy emits it as the CSS
// class "tag-<tag>" on each line item. This is the single source of truth: the row is
// hidden by a CSS rule on .tag-rebuy_hidden (in custom.css, flicker-free), and the same
// tag is excluded from the cart count below. CSS uses display:none, so the hidden <li>
// stays in the DOM and getHiddenCartHandles() can still read it.
var HIDDEN_CART_TAG = 'rebuy_hidden';

// Read the product handles of the line items Rebuy has tagged as hidden, straight from
// the rendered cart. /cart.js doesn't expose product tags, so to keep the count driven
// by the SAME tag that hides the row, we read the tag's effect (the tag-* class Rebuy
// renders) from the DOM and map each hidden row back to its product handle.
function getHiddenCartHandles() {
  var handles = [];
  document
    .querySelectorAll('.rebuy-cart__flyout-item.tag-' + HIDDEN_CART_TAG)
    .forEach(function (li) {
      var productClass = Array.prototype.find.call(li.classList, function (c) {
        return c.indexOf('product-') === 0;
      });
      if (productClass) {
        var handle = productClass.slice('product-'.length);
        if (handle && handles.indexOf(handle) === -1) handles.push(handle);
      }
    });
  return handles;
}

// Given a Shopify cart object (from /cart.js or a rebuy event), return the count
// excluding line items hidden by the rebuy_hidden tag. Returns null if unreadable.
function getVisibleCartCount(cart) {
  if (!cart || !Array.isArray(cart.items)) return null;
  var hiddenHandles = getHiddenCartHandles();
  var hiddenUnits = 0;
  cart.items.forEach(function (it) {
    // The ORDER_FEE line is excluded by SKU as well as by tag, so the count is
    // right even before the Rebuy DOM (where the tag classes live) has rendered.
    if (isOrderFeeItem(it) || hiddenHandles.indexOf(it.handle) !== -1) hiddenUnits += (it.quantity || 0);
  });
  return Math.max(0, (cart.item_count || 0) - hiddenUnits);
}

// Write the visible count to every cart-count badge (only if different, to avoid loops).
function applyVisibleCartCount(count) {
  if (count == null) return;
  window.__visibleCartCount = count;
  document.querySelectorAll('[data-cart-count], .cart-icon .cartCount').forEach(function (el) {
    if ((el.textContent || '').trim() !== String(count)) el.textContent = count;
  });
}

// Fetch the cart and correct all count badges. Used on load and after cart changes.
function refreshVisibleCartCount() {
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cart) { applyVisibleCartCount(getVisibleCartCount(cart)); })
    .catch(function () {});
}

// Other scripts (halo.js, recently-viewed, etc.) may reset the badge to the raw
// item_count. Re-apply our corrected value whenever a badge node changes.
function initVisibleCartCountObserver() {
  if (window.__visibleCartCountObserver) return;
  var observer = new MutationObserver(function () {
    if (window.__visibleCartCount == null) return;
    applyVisibleCartCount(window.__visibleCartCount);
  });
  document.querySelectorAll('[data-cart-count], .cart-icon .cartCount').forEach(function (el) {
    observer.observe(el, { childList: true, characterData: true, subtree: true });
  });
  window.__visibleCartCountObserver = observer;
}

// function that groups tasks which rely on cart information
// currently grouping six-pack check and header total update
function handleCartUpdate(event) {
  // Rebuy's cart events carry the cart; use it and skip a /cart.js round trip.
  const detail = event && event.detail;
  const eventCart = detail && detail.cart && detail.cart.cart;
  const cart = eventCart && typeof eventCart.total_price === 'number' ? eventCart : null;

  scheduleSixPackCheck();
  scheduleOrderFeeCheck();
  updateCartHeaderTotal(cart);
  refreshVisibleCartCount();
  initVisibleCartCountObserver();
  injectDeferredPayments();
}

document.addEventListener('rebuy:smartcart.ready', handleCartUpdate);
document.addEventListener('rebuy:smartcart.change', handleCartUpdate);
document.addEventListener('rebuy:cart.change', handleCartUpdate);

// Stores (and theme-dev previews) without Rebuy still get the fee guard: the
// WI drawer ecosystem fires these when the cart UI opens or re-renders.
// ensureOrderFee only re-dispatches after an actual change, so this converges.
document.addEventListener('updateCart', scheduleOrderFeeCheck);
document.addEventListener('opencart', scheduleOrderFeeCheck);

// The WI drawer announces every one of its own cart mutations (quantity +/-,
// remove, add-to-cart) with this event — run the full cart-reactive set, so the
// fee re-prices in the re-rendered drawer and is removed when the cart empties.
document.addEventListener('wi:cart.change', handleCartUpdate);

// Run once on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', handleCartUpdate);
} else {
  handleCartUpdate();
}

// ---------------------------------------------------------------------------
// Deferred payments ("Udskudte betalinger") accordion in the cart.
// Single-choice: selecting one option removes any other option in the same list.
// Rendered by snippets/wi-deferred-payments.liquid; injected with the cart footer,
// so listeners are delegated on document (the markup may be re-rendered by Rebuy).
// ---------------------------------------------------------------------------
function refreshRebuyCart() {
  if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.refresh === 'function') {
    window.Rebuy.SmartCart.refresh();
  } else {
    // Fallback: let other cart listeners pick up the change
    document.dispatchEvent(new CustomEvent('rebuy:cart.change'));
  }
}

// The Rebuy cart footer is built in the Rebuy dashboard (not the theme), so we can't render
// the accordion into it with Liquid. Instead we fetch the accordion from its dedicated section
// and insert it above the Rebuy footer on every cart render. The fresh fetch carries the
// correct checked state (which options are in the cart).
var __deferredInjecting = false;
async function injectDeferredPayments() {
  var footer =
    document.querySelector('[data-rebuy-cart-anchor="footer"]') ||
    document.querySelector('.rebuy-cart__flyout-footer');
  if (!footer || __deferredInjecting) return;
  __deferredInjecting = true;
  try {
    var res = await fetch('/?section_id=wi-deferred-payments', { headers: { Accept: 'text/html' } });
    if (!res.ok) return;
    var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    var fresh = doc.querySelector('.WI_deferredPayments');
    var existing = document.querySelector('.WI_deferredPayments[data-injected]');
    if (!fresh) {
      if (existing) existing.remove();           // accordion disabled/empty -> remove stale copy
      return;
    }
    fresh.setAttribute('data-injected', '');
    if (existing) {
      if (existing.classList.contains('is-open')) fresh.classList.add('is-open'); // keep open state
      existing.replaceWith(fresh);
    } else {
      footer.parentNode.insertBefore(fresh, footer);  // place above the footer
    }
  } catch (e) {
    console.error('Deferred payments injection failed', e);
  } finally {
    __deferredInjecting = false;
  }
}

function cartChangeRequest(body) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });
}

// Toggle the accordion open/closed
document.addEventListener('click', function (e) {
  var toggle = e.target.closest('[data-deferred-toggle]');
  if (!toggle) return;
  var wrap = toggle.closest('[data-deferred-payments]');
  if (wrap) wrap.classList.toggle('is-open');
});

// Add / remove a deferred-payment option (single choice)
document.addEventListener('change', async function (e) {
  var input = e.target.closest('[data-deferred-input]');
  if (!input) return;

  var wrap = input.closest('[data-deferred-payments]');
  var variantId = input.getAttribute('data-variant-id');
  var item = input.closest('[data-deferred-item]');
  if (item) item.classList.add('is-loading');

  try {
    if (input.checked) {
      // Single choice: uncheck + remove any other selected option in this list first
      var others = wrap ? wrap.querySelectorAll('[data-deferred-input]') : [];
      for (var i = 0; i < others.length; i++) {
        var other = others[i];
        if (other !== input && other.checked) {
          other.checked = false;
          await cartChangeRequest({ id: other.getAttribute('data-variant-id'), quantity: 0 });
        }
      }
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
    } else {
      await cartChangeRequest({ id: variantId, quantity: 0 });
    }
    refreshRebuyCart();
  } catch (err) {
    console.error('Deferred payment update failed', err);
  } finally {
    if (item) item.classList.remove('is-loading');
  }
});

// Categories info box read more/less toggle
document.addEventListener('DOMContentLoaded', function() {
  const readMoreBtn = document.querySelector('.categories-read-more-btn');
  const infoBox = document.querySelector('.categories-info-box');
  
  if (readMoreBtn && infoBox) {
    // Set initial button text
    const updateButtonText = () => {
      const isClosed = infoBox.getAttribute('data-state') === 'closed';
      if (window.theme && window.theme.strings) {
        readMoreBtn.textContent = isClosed ? window.theme.strings.show_more : window.theme.strings.show_less;
      } else {
        readMoreBtn.textContent = isClosed ? 'Show more' : 'Show less';
      }
    };
    
    updateButtonText();
    
    readMoreBtn.addEventListener('click', function() {
      const currentState = infoBox.getAttribute('data-state');
      infoBox.setAttribute('data-state', currentState === 'closed' ? 'open' : 'closed');
      updateButtonText();
    });
  }
});

/* show price of second variant (if exists) on quick view */
(function() {
  function updateQuickViewPrices() {
    // Target both search results and recommended products
    const productLists = document.querySelectorAll('.rebuy-quick-view__product-list');
    
    productLists.forEach(list => {
      // Handle both layout types: horizontal (DK) and grid (SE)
      const productCards = list.querySelectorAll(
        '.rebuy-quick-view__product-horizontal, .rebuy-quick-view__product'
      );
      
      productCards.forEach((card) => {
        // Check if already processed
        if (card.dataset.priceUpdated) return;
        
        const variantSelect = card.querySelector('.rebuy-select');
        if (!variantSelect || variantSelect.options.length < 2) return;
        
        const priceEl = card.querySelector('.price');
        if (!priceEl) return;

        // Get product handle from link
        const link = card.querySelector('a[href*="/products/"]');
        if (!link) return;
        
        const handle = link.href.match(/\/products\/([^?]+)/)?.[1];
        if (!handle) return;

        // Fetch product data via Shopify's API
        fetch(`/products/${handle}.js`)
          .then(res => res.json())
          .then(product => {
            if (!product.variants || product.variants.length < 2) return;
            
            const secondVariant = product.variants[1];
            const price = secondVariant.price;
            const compareAt = secondVariant.compare_at_price || null;

            priceEl.innerHTML = renderPrice(price, compareAt);
            card.dataset.priceUpdated = 'true';
          })
          .catch(err => console.error('Error fetching product:', err));
      });
    });
  }

  function renderPrice(price, compareAt) {
    const hasSale = compareAt && Number(compareAt) > Number(price);

    if (!hasSale) {
      return `
        <span class="rebuy-money">
          <span class="sr-only">Price</span>
          <span>${Shopify.formatMoney(price, window.money_format)}</span>
        </span>
      `;
    }

    return `
      <span class="rebuy-money sale">
        <span class="sr-only">Sale price</span>
        <span>${Shopify.formatMoney(price, window.money_format)}</span>
      </span>
      <span class="rebuy-money compare-at">
        <span class="sr-only">Original price</span>
        <span>${Shopify.formatMoney(compareAt, window.money_format)}</span>
      </span>
    `;
  }

  // When quick view first opens
  document.addEventListener('rebuy:smartsearch.quickview.open', () => {
    setTimeout(updateQuickViewPrices, 150);
  });

  // When products change as user types
  document.addEventListener('rebuy:smartsearch.quickview.productsChange', () => {
    setTimeout(updateQuickViewPrices, 150);
  });
})();